import { render } from "./ShowBusinessPartnerProfile.vue?vue&type=template&id=67a6fafb&scoped=true"
import script from "./ShowBusinessPartnerProfile.vue?vue&type=script&lang=js"
export * from "./ShowBusinessPartnerProfile.vue?vue&type=script&lang=js"

import "./ShowBusinessPartnerProfile.vue?vue&type=style&index=0&id=67a6fafb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a6fafb"]])

export default __exports__